import { render, staticRenderFns } from "./IconReport.vue?vue&type=template&id=5b1270e3&"
import script from "./IconReport.vue?vue&type=script&lang=ts&"
export * from "./IconReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports